<script setup lang="ts">
// TODO: replace this component with <b-alert>

withDefaults(
  defineProps<{type?: string}>(),
  {type: "info"},
)
</script>

<template>
  <div :class="['alert', `alert-${type}`]">
    <slot/>
  </div>
</template>
